<loading-component>
  <div slot="start">
    <img alt="" src="assets/images/loading/redirect.webp"
      srcset="assets/images/loading/redirect@2x.webp 2x, assets/images/loading/redirect@3x.webp 3x">
    <div class="title">{{ 'LOGIN_REDIRECT.TITLE' | translate }}</div>
    <div class="loading__description">{{ 'LOGIN_REDIRECT.DESCRIPTION' | translate }}</div>
  </div>
</loading-component>